import BreakdownHOK from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/BreakdownHOK';

const FundDetailsBreakdownMaturityProfileTable = () => {
  return <BreakdownHOK endpoint="maturity" titleKey="fundDetailsBreakdownMaturityTitle" />;
};

export default FundDetailsBreakdownMaturityProfileTable;
